import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TransactionFailedRecord } from "../../../model/Transaction";
import { ImportUsersService } from "../../../services/import-users.service";
import { EventEmitterWithObservable } from '../../../../shared/EventEmitterWithValueReturned';

@Component({
    selector: 're-import-user-failed',
    templateUrl: './import-user-failed.component.html',
    styleUrls: ['./import-user-failed.component.scss'],
    standalone: false
})
export class ImportUserFailedComponent {
  constructor(private importUsersService: ImportUsersService, private route: ActivatedRoute) { }

  failedUsers: TransactionFailedRecord[];

  load($event: EventEmitterWithObservable) {
    $event.ReturnValue = this.importUsersService.getFailedUsers(+this.route.snapshot.params.processId);
  }
}
